export default function RadioCard({
  selected = false,
  onClick,
  title,
  description,
  icon,
  onIconClick,
  disabled = false,
  className = "",
  chipText
}) {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={selected}
      disabled={disabled}
      onClick={() => !disabled && onClick?.()}
      className={[
        // base layout
        "w-full text-left flex items-start gap-3 rounded-xl px-4 py-3 transition-all duration-200",
        // border
        selected
          ? "border-2 border-primary bg-blue-50/60"
          : "border-2 border-gray-200 bg-white hover:border-gray-300",
        // disabled
        disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {/* Radio circle */}
      <span
        className={[
          "mt-0.5 flex-shrink-0 w-[18px] h-[18px] rounded-full border-2 flex items-center justify-center transition-colors duration-200",
          selected ? "border-primary" : "border-gray-400",
        ].join(" ")}
      >
        {selected && (
          <span className="w-[8px] h-[8px] rounded-full bg-primary block" />
        )}
      </span>
 
      {/* Text content */}
      <span className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
           {title && (
          <span className="block text-[16px] font-semibold text-gray-900 leading-snug">
            {title}
          </span>
        )}
 {chipText && (
            <span className="text-xs text-primary bg-primary/10 px-3 py-1 rounded-full">
              {chipText}
            </span>
          )}
        </div>
       
        {description && (
          <span className="block text-sm text-gray-500 leading-snug mt-0.5">
            {description}
          </span>
        )}
      </span>
 
      {/* Optional icon button */}
      {icon && (
        <span
          role={onIconClick ? "button" : undefined}
          tabIndex={onIconClick ? 0 : undefined}
          onClick={(e) => {
            if (onIconClick) {
              e.stopPropagation();
              onIconClick(value);
            }
          }}
          onKeyDown={(e) => {
            if (onIconClick && (e.key === "Enter" || e.key === " ")) {
              e.stopPropagation();
              onIconClick(value);
            }
          }}
          className={[
            "flex-shrink-0 flex items-center justify-center w-8 h-8 rounded-lg border border-gray-200 bg-white text-gray-500 transition-colors duration-150",
            onIconClick
              ? "hover:border-blue-400 hover:text-primary cursor-pointer"
              : "",
          ].join(" ")}
        >
          {icon}
        </span>
      )}
    </button>
  );
}